import "./Packages.module.css";
import Header from "@/reusable_sections/Header";
import PackageFaq from "./sections/PackageFaq";
import Flowerbarpackages from "./sections/Flowerbarpackages";
import Footer from "@/reusable_sections/Footer";
export default function PackagesPage() {
  return <div>
      <Header />
      <Flowerbarpackages />
      <PackageFaq />
      <Footer />
    </div>;
}